import { createRequest } from '@shared/services';

export async function postProductSeoContent(payload: ProductSeoContent) {
    const request = createRequest<PostProductSeoContentResponse>({
        url: `/product/seo-content`,
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}
